import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
import { clearUserData } from './entities';
export const updateCurrentCustomerProfile = createAsyncThunk('customer/profile/update', async (updateProfileData, thunkApi) => {
    try {
        return await (await api.instance).updateProfile(updateProfileData);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const fetchCurrentCustomer = createAsyncThunk('customer/fetch', async (_, thunkApi) => {
    try {
        return await (await api.instance).fetchCurrentCustomer();
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
const initialState = {
    status: 'init'
};
function isRejectedAction(action) {
    return action.type.startsWith('customer/') && action.type.endsWith('/rejected');
}
const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        resetAuthentication: (state) => {
            state.error = undefined;
            state.status = 'init';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(clearUserData.fulfilled, (state) => (state = initialState))
            .addCase(fetchCurrentCustomer.fulfilled, (state, action) => {
            state.status = 'success';
            state.customer = action.payload;
        })
            .addCase(fetchCurrentCustomer.pending, (state) => {
            state.status = 'fetching';
            state.error = undefined;
        })
            .addCase(updateCurrentCustomerProfile.fulfilled, (state, action) => {
            state.status = 'success';
            state.customer = action.payload;
        })
            .addCase(updateCurrentCustomerProfile.pending, (state) => {
            state.status = 'updating';
            state.error = undefined;
        })
            .addMatcher(isRejectedAction, (state, action) => {
            state.error = action.payload;
            state.status = 'error';
        });
    }
});
export const customerReducer = customerSlice.reducer;
